import UploadThumbWrapper from './UploadThumbWrapper';
import UploadThumbContainer from './UploadThumb.container';
import UploadThumb from './UploadThumb';
export default UploadThumbWrapper(UploadThumbContainer(UploadThumb));
//# sourceMappingURL=index.js.map